import { FunctionComponent } from 'react';

import { Milestone } from '../../../../apollo/__generated__/graphql';
import { useCurrentMilestone } from '../../../../event/hooks/useCurrentMilestone';

interface MilestoneCellProps {
  milestones: Milestone[];
}

export const MilestoneCell: FunctionComponent<MilestoneCellProps> = ({
  milestones,
}) => {
  const currentMilestone = useCurrentMilestone(milestones);

  return currentMilestone
    ? `${currentMilestone.name} - ${currentMilestone.prices.map((price) => `${price.day + 1}j : ${price.value / 100}€`).join(', ')}`
    : 'Aucun Palier actuellement';
};
